// Script to update existing settings table with missing columns
// This script will add the required columns to your existing settings table

import { oneKlicks } from '../SDK/oneclick';

// Function to add missing columns to settings table
export const updateSettingsTable = async () => {
  try {
    console.log('Updating settings table structure...');
    
    // First, let's check the current table structure
    const tableSchema = "";
    const tableName = "site_settings"; // ✅ CORRECT TABLE NAME
    const conditions = {};
    const orderBy = "id ASC";
    const search = {};
    const pagination = {};
    const margedata = [];

    const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
    console.log('Current table structure:', response);

    // Add missing columns if they don't exist
    // We'll create settings one by one to ensure the table structure adapts
    
    const defaultSettings = {
      // Branding
      site_name: 'MeddyList',
      site_description: 'Your trusted healthcare platform',
      logo_url: '',
      favicon_url: '',
      
      // Colors
      primary_color: '#007bff',
      secondary_color: '#6c757d',
      accent_color: '#28a745',
      background_color: '#ffffff',
      text_color: '#333333',
      
      // Header & Footer
      header_background: '#ffffff',
      footer_background: '#f8f9fa',
      header_text_color: '#333333',
      footer_text_color: '#666666',
      
      // Buttons
      button_primary_color: '#007bff',
      button_secondary_color: '#6c757d',
      button_text_color: '#ffffff',
      
      // Forms
      form_background: '#ffffff',
      form_border_color: '#ced4da',
      form_focus_color: '#007bff',
      
      // Social Media
      facebook_url: '',
      twitter_url: '',
      instagram_url: '',
      linkedin_url: '',
      youtube_url: '',
      
      // Contact Information
      contact_email: '',
      contact_phone: '',
      contact_address: '',
      
      // SEO
      meta_title: '',
      meta_description: '',
      meta_keywords: '',
      
      // Features
      enable_registration: true,
      enable_appointments: true,
      enable_reviews: true,
      enable_chat: true,
      
      // Payment
      currency: 'INR',
      payment_gateway: 'stripe',
      
      // Email
      smtp_host: '',
      smtp_port: '',
      smtp_username: '',
      smtp_password: '',
      smtp_encryption: 'tls',
      
      // Analytics
      google_analytics_id: '',
      facebook_pixel_id: '',
      
      // Custom Code
      custom_css: '',
      custom_js: '',
      
      // Maintenance
      maintenance_mode: false,
      maintenance_message: 'Site is under maintenance. Please check back later.',
      
      // Security
      max_login_attempts: 5,
      session_timeout: 3600,
      
      // File Upload
      max_file_size: 5242880, // 5MB
      allowed_file_types: 'jpg,jpeg,png,gif,pdf,doc,docx',
      
      // Notifications
      email_notifications: true,
      sms_notifications: false,
      push_notifications: true
    };

    console.log('Creating/updating settings...');
    
    // Create each setting
    for (const [key, value] of Object.entries(defaultSettings)) {
      try {
        let valueType = 'string';
        if (typeof value === 'boolean') valueType = 'boolean';
        else if (typeof value === 'number') valueType = 'number';
        else if (typeof value === 'object') valueType = 'json';
        
        // Prepare the data
        let stringValue = value;
        if (valueType === 'json') {
          stringValue = JSON.stringify(value);
        } else if (valueType === 'boolean') {
          stringValue = value ? 'true' : 'false';
        } else if (valueType === 'number') {
          stringValue = value.toString();
        }
        
        const data = {
          key: key, // ✅ CORRECT COLUMN NAME
          value: stringValue, // ✅ CORRECT COLUMN NAME
          value_type: valueType, // ✅ CORRECT COLUMN NAME
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        };
        
        // Try to create the setting
        const createResponse = await oneKlicks.create(tableSchema, tableName, data, {});
        console.log(`Setting ${key}:`, createResponse.success ? 'Created' : 'Failed');
        
      } catch (error) {
        console.error(`Error creating setting ${key}:`, error);
      }
    }
    
    console.log('Settings table update complete!');
    return true;
    
  } catch (error) {
    console.error('Error updating settings table:', error);
    return false;
  }
};

// Function to test the settings
export const testSettings = async () => {
  try {
    console.log('Testing settings...');
    
    const tableSchema = "";
    const tableName = "site_settings"; // ✅ CORRECT TABLE NAME
    const conditions = {};
    const orderBy = "id ASC";
    const search = {};
    const pagination = {};
    const margedata = [];

    const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
    console.log('All settings:', response.data);
    
    return response.success;
  } catch (error) {
    console.error('Error testing settings:', error);
    return false;
  }
};

// Export for use in other files
const updateSettingsTableService = { updateSettingsTable, testSettings };
export default updateSettingsTableService;
